import * as fromDatatype from "../datatype-library/index";

export interface bl_mkp_mst_label_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_label_hdr: fromDatatype.GuidDataFieldInterface;
    merchant_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_hdr_guid: fromDatatype.VarcharDatatypeInterface;
    mkp_item_line_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
}

export class bl_mkp_mst_label_link_RowClass implements bl_mkp_mst_label_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_label_hdr: fromDatatype.GuidDataFieldInterface;
    merchant_guid: fromDatatype.GuidDataFieldInterface;
    mkp_item_hdr_guid: fromDatatype.VarcharDatatypeInterface;
    mkp_item_line_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
}